/**
 * This file contains many functions that make calls to our API and return the promises from those calls.
 */

import axios from 'axios';
import { get } from 'lodash';

import qs from 'qs';
import { toast } from 'react-toastify';

import Api from '../api.ts';

const COMPLIANCE = '/compliance';

const ComplianceAPI = {
  async uploadApprovalSignatures(file, vendorId, onProgressCallback) {
    const fileType = file.type;
    const url = `${COMPLIANCE}/approval-signatures?${qs.stringify({
      vendorId,
      fileType,
    })}`;
    const response = await Api.get(url);

    axios({
      method: 'put',
      url: get(response, `write`),
      data: file,
      headers: {
        'Content-Type': fileType,
      },
      onUploadProgress: (progressEvent) => {
        onProgressCallback({
          total: progressEvent.total,
          loaded: progressEvent.loaded,
          timeStamp: progressEvent.timeStamp,
        });
      },
    })
      .then(() => {
        toast('File successfully uploaded', { type: 'success' });
      })
      .catch((error) => {
        console.log('File upload error: ', error);
        toast('Something went wrong in file upload', {
          type: 'error',
        });
      });

    return response;
  },
};

export default ComplianceAPI;
